import React, { Component } from "react";
import { RichUtils } from "draft-js";
import { Button, Icon } from "semantic-ui-react";

class BlockStyleButton extends Component {
  state = {
    active: false
  };
  toggleStyle = event => {
    event.preventDefault();
    this.props.setEditorState(
      RichUtils.toggleBlockType(this.props.getEditorState(), this.props.type)
    );
  };
  preventBubble = event => event.preventDefault();

  async componentDidUpdate(prevProps) {
    if (prevProps.getEditorState) {
      const currentActiveStatus = this.isStyleActive();
      if (currentActiveStatus !== this.state.active) {
        this.setState({ active: currentActiveStatus });
      }
    }
  }
  isStyleActive = () => {
    if (!this.props.getEditorState) {
      return false;
    }
    const editorState = this.props.getEditorState();
    return (
      editorState
        .getCurrentContent()
        .getBlockForKey(editorState.getSelection().getStartKey())
        .getType() === this.props.type
    );
  };
  render() {
    return (
      <div onMouseDown={this.preventBubble}>
        <Button icon active={this.state.active} onClick={this.toggleStyle}>
          {this.props.children}
        </Button>
      </div>
    );
  }
}

export const UnorderedListButton = externalProps => (
  <BlockStyleButton type="unordered-list-item" {...externalProps}>
    <Icon name="unordered list" />
  </BlockStyleButton>
);

export const OrderedListButton = externalProps => (
  <BlockStyleButton type="ordered-list-item" {...externalProps}>
    <Icon name="ordered list" />
  </BlockStyleButton>
);

export const BlockQuoteButton = externalProps => (
  <BlockStyleButton type="blockquote" {...externalProps}>
    <Icon name="quote right" />
  </BlockStyleButton>
);

export const HeaderOneButton = externalProps => (
  <BlockStyleButton type="header-one" {...externalProps}>
    H1
  </BlockStyleButton>
);

export const HeaderTwoButton = externalProps => (
  <BlockStyleButton type="header-two" {...externalProps}>
    H2
  </BlockStyleButton>
);
export const HeaderThreeButton = externalProps => (
  <BlockStyleButton type="header-three" {...externalProps}>
    H3
  </BlockStyleButton>
);



// WEBPACK FOOTER //
// ./src/pages/Contents/New/EditorButtons/BlockStyleButtons.js